(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('parseMIMEByRFC2047', function () {
        function stringToTypedArray(buffer) {
            var typedarray = new Uint8Array(buffer.length);
            for (var i = 0; i < buffer.length; i++)
                typedarray[i] = buffer.charCodeAt(i);
            return typedarray;
        }
        function decode_base64(buffer, more) {
            // Drop all non-base64 characters
            var sanitize = buffer.replace(/[^A-Za-z0-9+\/=]/g, '');
            // We need to encode in groups of 4 chars. If we don't have enough, leave the
            // excess for later. If there aren't any more, drop enough to make it 4.
            var excess = sanitize.length % 4;
            if (excess !== 0 && more)
                buffer = sanitize.slice(-excess);
            else
                buffer = '';
            sanitize = sanitize.substring(0, sanitize.length - excess);
            // Use the atob function we (ought to) have in global scope.
            return [
                atob(sanitize),
                buffer
            ];
        }
        function decode_qp(buffer, more) {
            // Unlike base64, quoted-printable isn't stateful across multiple lines, so
            // there is no need to buffer input, so we can always ignore more.
            var decoded = buffer.replace(// Replace either =<hex><hex> or =<wsp>CRLF
            /=([0-9A-F][0-9A-F]|[ \t]*(\r\n|[\r\n]|$))/gi, function replace_chars(match, param) {
                // If trailing text matches [ \t]*CRLF, drop everything, since it's a
                // soft line break.
                if (param.trim().length === 0)
                    return '';
                return String.fromCharCode(parseInt(param, 16));
            });
            return [
                decoded,
                ''
            ];
        }
        /**
     * Decodes all 2047 words in the input string.
     */
        function decode2047Words(headerValue) {
            headerValue = headerValue || '';
            // Unfortunately, many implementations of RFC 2047 encoding are actually wrong
            // in that they split over-long encoded words without regard for whether or
            // not the split point is in the middle of a multibyte character. Therefore,
            // we need to be able to handle these situations gracefully. This is done by
            // using the decoder in streaming mode so long as the next token is another
            // 2047 token with the same charset.
            var lastCharset = '', currentDecoder;
            /// Decode a single RFC 2047 token.
            function decode2047Token(token) {
                var tokenParts = token.split('?');
                // If it's obviously not a valid token, return false immediately.
                if (tokenParts.length != 5 || tokenParts[4] != '=')
                    return false;
                // The charset parameter is defined in RFC 2231 to be charset or
                // charset*language. We only care about the charset here, so ignore any
                // language parameter that gets passed in.
                var charset = tokenParts[1].split('*', 1)[0];
                var encoding = tokenParts[2], text = tokenParts[3];
                var buffer;
                if (encoding == 'B' || encoding == 'b') {
                    // Decode base64. If there's any non-base64 data, treat the string as
                    // an illegal token.
                    if (/[^A-Za-z0-9+\/=]/.exec(text))
                        return false;
                    // Base64 strings must be a length of multiple 4, but it seems that some
                    // mailers accidentally insert one too many `=' chars. Gracefully handle
                    // this case; see bug 227290 for more information.
                    if (text.length % 4 == 1 && text.charAt(text.length - 1) == '=')
                        text = text.slice(0, -1);
                    // Decode the string
                    buffer = decode_base64(text, false)[0];
                } else if (encoding == 'Q' || encoding == 'q') {
                    // Q encoding here looks a lot like quoted-printable text. The differences
                    // between quoted-printable and this are that quoted-printable allows you
                    // to quote newlines (this doesn't), while this replaces spaces with _.
                    // We can reuse the decode_qp code here, since newlines are already
                    // stripped from the header. There is one edge case that could trigger a
                    // false positive, namely when you have a single = or an = followed by
                    // whitespace at the end of the string. Such an input string is already
                    // malformed to begin with, so stripping the = and following input in that
                    // case should not be an important loss.
                    buffer = decode_qp(text.replace('_', ' ', 'g'), false)[0];
                } else {
                    return false;
                }
                // Make the buffer be a typed array for what follows
                buffer = stringToTypedArray(buffer);
                // If we cannot reuse the last decoder, flush out whatever remains.
                var output = '';
                if (charset != lastCharset && currentDecoder) {
                    output += currentDecoder.decode();
                    currentDecoder = null;
                }
                // Initialize the decoder for this token.
                lastCharset = charset;
                if (!currentDecoder) {
                    try {
                        currentDecoder = new TextDecoder(charset, { fatal: false });
                    } catch (e) {
                        // We don't recognize the charset, so give up.
                        return false;
                    }
                }
                // Convert this token with the buffer.
                return output + currentDecoder.decode(buffer, { stream: true });
            }
            // The first step of decoding is to split the string into RFC 2047 and
            // non-RFC 2047 tokens. RFC 2047 tokens look like the following:
            // =?charset?c?text?=, where c is one of B, b, Q, and q. The split regex does
            // some amount of semantic checking, so that malformed RFC 2047 tokens will
            // get ignored earlier.
            var components = headerValue.split(/(=\?[^?]*\?[BQbq]\?[^?]*\?=)/);
            for (var i = 0; i < components.length; i++) {
                if (components[i].substring(0, 2) == '=?') {
                    var decoded = decode2047Token(components[i]);
                    if (decoded !== false) {
                        // If 2047 decoding succeeded for this bit, rewrite the original value
                        // with the proper decoding.
                        components[i] = decoded;
                        // We're done processing, so continue to the next link.
                        continue;
                    }
                } else if (/^[ \t\r\n]*$/.exec(components[i])) {
                    // Whitespace-only tokens get squashed into nothing, so 2047 tokens will
                    // be concatenated together.
                    components[i] = '';
                    continue;
                }
                // If there was stuff left over from decoding the last 2047 token, flush it
                // out.
                lastCharset = '';
                if (currentDecoder) {
                    components[i] = currentDecoder.decode() + components[i];
                    currentDecoder = null;
                }
            }
            // After the for loop, we'll have a set of decoded strings. Concatenate them
            // together to make the return value.
            return components.join('');
        }
        return {
            decode: function (input) {
                try {
                    return input && _(input).isString() ? decode2047Words(input) : input;
                } catch (e) {
                    console.log('headerValue: ', input, ' Error on parsing mime:', e);
                    return input;
                }
            }
        };
    });
}());